import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { AppService } from 'src/app/app.service';
import { GlobalConstantsComponent } from '../../common/global-constants/global-constants.component';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {
  public clients:any;
  public clients_img:any;
  public config: SwiperConfigInterface = { };
  constructor(public appService:AppService,public http: HttpClient,) { }

  ngOnInit() {
    // this.clients = this.appService.getClients();
  
      this.http.get(GlobalConstantsComponent.apiURL+'/ourclient?'.toString())
      .subscribe((response: any) =>{
        this.clients=response.Ourclients;
        this.clients_img=GlobalConstantsComponent.siteUrl+'/assets/serverimg/';
      })
    
  }

  ngAfterViewInit(){
    this.config = {
      observer: true,
      slidesPerView: 7,
      spaceBetween: 16,       
      keyboard: true,
      navigation: false,
      pagination: false,
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true,  
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      speed: 500,
      effect: "slide",
      breakpoints: {
        320: {
          slidesPerView: 2
        },
        480: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 4
        },
        960: {
          slidesPerView: 5
        },
        1280: {
          slidesPerView: 6
        },
        1500: {
          slidesPerView: 7
        }
      }
    }
  }

}